import axios from "../customize/axios";

const getDataUser = async (licensePlate, employeeId) => {
  try {
    // console.log("licensePlate được gửi đi:", licensePlate);
    // console.log("employeeId được gửi đi:", employeeId);
    const response = await axios.get("/api/employee/manager/", {
      params: { licensePlate, employeeId },
    });
    return response;
  } catch (error) {
    console.error("Error at getDataUser in employeeServices:", error);
  }
};

const getEmployee = async (employeeCode) => {
  // console.log("employeeCode được gửi đi:", employeeCode);
  try {
    const response = await axios.get("/api/employee/getInforEmployee/", {
      params: { employeeCode },
    });
    return response;
  } catch (error) {
    console.error("Error at getEmployee in employeeServices:", error);
  }
};

const getAssignedParkingLotHistory = async (employeeCode, parkingLotId) => {
  return axios.get('/api/employee/parking-lot-history/', {
    params: { employeeCode, parkingLotId },
  });
};

const updateTicketAndUserMongo = async (licensePlate, parkingLotId) => { //khách vãng lai đi ra
  try {
    const response = await axios.put(
      "/api/employee/updateTicketAndUserMongo/",
      {
        licensePlate: licensePlate,
        parkingLotId: parkingLotId,
      }
    );
    return response;
  } catch (error) {
    console.error(
      "Error at updateTicketAndUserMongo in employeeServices:",
      error
    );
  }
};

const updateTicketAndUser = async (licensePlate, parkingLotId, price, newRecordHistoryInOut) => {  //khách có tài khoản đi ra
  try {
    const response = await axios.put("/api/employee/updateTicketAndUser/", {
      licensePlate: licensePlate,
      parkingLotId: parkingLotId,
      price: price,
      historyRecord: newRecordHistoryInOut
    });
    return response;
  } catch (error) {
    console.error("Error at updateTicketAndUser in employeeServices:", error);
  }
};

const addTicketMongo = async (licensePlate, parkingLotId) => {
  try {
    // Thông tin gửi đi
    // console.log("licensePlate:", licensePlate);
    // console.log("parkingLotId:", parkingLotId);
    const response = await axios.post("/api/employee/addTicketMongo/", {
      licensePlate: licensePlate,
      parkingLotId: parkingLotId,
    });
    return response;
  } catch (error) {
    console.error("Error at addTicketMongo in employeeServices:", error);
  }
};

const addTicket = async (parkingLotId, vehicleId) => {
  try {
    const response = await axios.post("/api/employee/addTicket/", {
      parkingLotId: parkingLotId,
      vehicleId: vehicleId,
    });
    return response;
  } catch (error) {
    console.error("Error at addTicket in employeeServices:", error);
  }
};

const getAllTicket = (userCode) => {
  try {
    const response = axios.get("/api/employee/getAllTicket/", {
      params: { userCode },
    });
    return response;
  } catch (error) {
    console.log("Error at getAllTicket in employeeServices: ", error);
  }
};
const getAllTicketInArea = (userCode) => {
  try {
    const response = axios.get("/api/employee/getAllTicketInArea/", {
      params: { userCode },
    });
    return response;
  } catch (error) {
    console.log("Error at getAllTicketInArea in employeeServices: ", error);
  }
};
const getAllTicketOutArea = (userCode) => {
  try {
    const response = axios.get("/api/employee/getAllTicketOutArea/", {
      params: { userCode },
    });
    return response;
  } catch (error) {
    console.log("Error at getAllTicketOutArea in employeeServices: ", error);
  }
};

const getTicketByLicensePlate = (userCode, licensePlate) => {
  try {
    const response = axios.get("/api/employee/getTicketByLicensePlate/", {
      params: { userCode, licensePlate },
    });
    return response;
  } catch (error) {
    console.log("Error at getTicketByLicensePlate in employeeServices: ", error);
  }
};

const getTicketByLicensePlateInArea = (userCode, licensePlate) => {
  try {
    const response = axios.get("/api/employee/getTicketByLicensePlateInArea/", {
      params: { userCode, licensePlate },
    });
    return response;
  } catch (error) {
    console.log("Error at getTicketByLicensePlateInArea in employeeServices: ", error);
  }
}

const getTicketByLicensePlateOutArea = (userCode, licensePlate) => {
  try {
    const response = axios.get("/api/employee/getTicketByLicensePlateOutArea/", {
      params: { userCode, licensePlate },
    });
    return response;
  } catch (error) {
    console.log("Error at getTicketByLicensePlateOutArea in employeeServices: ", error);
  }
}

export {
  getEmployee,
  getAssignedParkingLotHistory,
  updateTicketAndUserMongo,
  getDataUser,
  updateTicketAndUser,
  addTicketMongo,
  addTicket,
  getAllTicket,
  getAllTicketInArea,
  getAllTicketOutArea,
  getTicketByLicensePlate,
  getTicketByLicensePlateInArea,
  getTicketByLicensePlateOutArea,
};
